import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import AddressBar_vue_vue_type_script_setup_true_lang_default from "./AddressBar.vue.script.js";
/* empty css                         */
//#region src/v2/blocks/scalar-address-bar-block/components/AddressBar.vue
var AddressBar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(AddressBar_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-65ff0ebf"]]);
//#endregion
export { AddressBar_default as default };

//# sourceMappingURL=AddressBar.vue.js.map